import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTransaction } from '../../../context/TransactionContext';
import AutocompleteFilter, { FilterOption } from './AutocompleteFilter';
import { getDisplayCoin } from '../../../utils/displayFormatters';

interface AssetProps {
    value?: string[];
    onChange: (value: string[]) => void;
}

const Asset: React.FC<AssetProps> = ({value = [], onChange }) => {
    const { t } = useTranslation();
    const { userCoins: assets } = useTransaction();
    const options: FilterOption[] = (assets || [])
        .filter((asset) => asset.ticker && asset.name)
        .map((asset) => ({
            id: asset.ticker,
            label: `${asset.name} (${getDisplayCoin(asset.symbol, asset.ticker)})`,
        }));

    return (
        <AutocompleteFilter
            options={options}
            value={value}
            onChange={onChange}
            label={t('transactions.filters.asset.label')}
            placeholder={t('transactions.filters.asset.placeholder')}
        />
    );
};

export default Asset;
